<template lang="pug" src="./block-header.pug"></template>

<script>
export default {
  props: {
    props: {
      Type: Object
    },
    title: {
      Type: String,
      default: 'center'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/block/block-header/block-header.vue